import styled, { css } from "styled-components";
import theme from "../../theme/theme";

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  height: fit-content;
  text-align: center;
  padding: 0.7em 1.4em;
  color: ${(p) => p.color || theme.colors.primary};
  background-color: ${(p) => p.bg || "transparent"};
  border: ${(p) => p.borderWidth || "3px"} solid
    ${(p) => p.borderColor || "transparent"};
  border-radius: 5px;
  font-weight: ${(p) => p.fontWeight || "normal"};
  font-size: ${(p) => p.fontSize || "1em"};
  white-space: nowrap;
  text-rendering: optimizeLegibility;

  &[disabled] {
    opacity: 0.75;
    cursor: not-allowed;
  }

  ${(props) =>
    props.primary
      ? css`
          background-color: ${theme.colors.primary};
          color: white;
        `
      : ""}

  ${(props) =>
    props.secondary
      ? css`
          border-color: ${theme.colors.primary};
          color: ${theme.colors.primary};
        `
      : ""}

  &.secondary {
    border-right: none !important;
  }

  &.primary {
    background-color: ${(p) => theme.colors.primary};
    color: white;
  }

  svg {
    min-width: 15px;
    margin-right: 15px;
  }

  &.sm-onlyIcon {
    @media (max-width: 480px) {
      font-size: 0;
      place-items: center;
      padding: 10px;

      svg {
        margin: 0;
      }
    }
  }

  @media (max-width: 480px) {
    display: block;
    width: 100%;
    margin-top: 5%;
  }
`;

const Button = ({
  border,
  className,
  color,
  bg,
  borderColor,
  height,
  onClick,
  radius,
  width,
  isPrev,
  isNext,
  disabled,
  fontWeight,
  fontSize,
  children,
  primary,
  secondary,
}) => {
  return (
    <Btn
      onClick={onClick}
      disabled={disabled}
      fontWeight={fontWeight}
      color={color}
      borderColor={borderColor}
      fontSize={fontSize}
      bg={bg}
      primary={primary}
      secondary={secondary}
      className={className}
    >
      {children}
    </Btn>
  );
};

export default Button;
